import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {faTrash, faSave, faPlus} from '@fortawesome/free-solid-svg-icons';
import {EditService} from '../shared/services/editService/edit.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @Output()
  remove = new EventEmitter();

  @Output()
  create = new EventEmitter();

  @Output()
  add = new EventEmitter();

  faTrash = faTrash;
  faSave = faSave;
  faPlus = faPlus;

  @Input()
  deleteToolTip;

  @Input()
  createToolTip;

  @Input()
  addToolTip;

  @Input()
  plusButton = false;

  @Input()
  editButton = false;

  private _new: string;
  private _edit: string;
  private _isNew: boolean;
  private _form;

  constructor(private editService: EditService) { }

  ngOnInit() {
  }

  removeItem(){
    this.remove.emit();
  }

  createItem(){
    this.create.emit();
  }

  addButton() {
    this.add.emit();
  }

  isEdit(){
    return this.editService.editable;
  }

  @Input()
  set new(value: string) {
    this._new = value;
  }

  @Input()
  set edit(value: string) {
    this._edit = value;
  }

  @Input()
  set isNew(value: boolean) {
    this._isNew = value;
  }

  @Input()
  set form(value) {
    this._form = value;
  }

  get new(): string {
    return this._new;
  }

  get edit(): string {
    return this._edit;
  }

  get isNew(): boolean {
    return this._isNew;
  }

  get form() {
    return this._form;
  }
}
